module.exports = __webpack_public_path__ + "img/joy_04.efee31ed.png";